import qs from 'qs';
import api, { ApiRequestConfig } from '../../../api';
import { ResponseSuccess } from '../../../shared/types';
import type {
  DwdConnectedEmailsQuery,
  DwdConnectedEmailsResponse,
  DwdSyncPreviewQuery,
  DwdWorkspaceListItem,
  SyncDwdWorkspacePayload,
} from '../types';

export const getDwdWorkspaces = () =>
  api.get<DwdWorkspaceListItem[] | ResponseSuccess>('/dwd-workspace/workspaces');

export const createDwdWorkspace = (adminEmail: string) =>
  api.post<ResponseSuccess>('/dwd-workspace/google/workspace', { adminEmail });

export const getDwdWorkspaceSyncPreview = (
  workspaceId: string,
  params: DwdSyncPreviewQuery,
) =>
  api.get<ResponseSuccess>(
    `/dwd-workspace/${workspaceId}/sync-preview?${qs.stringify(params, {
      skipNulls: true,
    })}`,
    { skipGlobalErrorToast: true } as ApiRequestConfig,
  );

export const syncDwdWorkspace = (
  workspaceId: string,
  payload: SyncDwdWorkspacePayload,
) => api.post<ResponseSuccess>(`/dwd-workspace/${workspaceId}/sync`, payload);

export const getMicrosoftBulkConsentUrl = () =>
  api.get<ResponseSuccess>('/dwd-workspace/microsoft-bulk/consent-url');

export const createMicrosoftWorkspace = (tenantId: string, state: string) =>
  api.post<ResponseSuccess>('/dwd-workspace/microsoft/workspace', {
    tenantId,
    state,
  });

export const getConnectedEmails = (
  workspaceId: string,
  params: DwdConnectedEmailsQuery,
) =>
  api.get<DwdConnectedEmailsResponse | ResponseSuccess>(
    `/dwd-workspace/${workspaceId}/connected-emails?${qs.stringify(params, {
      skipNulls: true,
    })}`,
  );

export const deleteDwdEmailAccount = (
  workspaceId: string,
  emailAccountId: number,
) =>
  api.delete<ResponseSuccess>(
    `/dwd-workspace/${workspaceId}/email-account/${emailAccountId}`,
  );

export const disconnectDwdEmailAccount = (
  workspaceId: string,
  emailAccountId: number,
) =>
  api.post<ResponseSuccess>(
    `/dwd-workspace/${workspaceId}/email-account/${emailAccountId}/disconnect`,
  );

export const reconnectDwdEmailAccount = (workspaceId: string, email: string) =>
  api.post<ResponseSuccess>(
    `/dwd-workspace/${workspaceId}/email-account/reconnect`,
    { email },
  );
